import { Component} from '@angular/core';


@Component({
  selector: 'wtc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor() {
  }
}
